const UNIQUE_SEPARATOR = '--';

export const slugifyRouteName = (value) => {
  const normalized = String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return normalized || 'item';
};

export const namedRoutePath = (basePath, name, storedSlug) => {
  const base = String(basePath || '').replace(/\/$/, '');
  return `${base}/${encodeURIComponent(storedSlug || slugifyRouteName(name))}`;
};

export const routeIdentifier = (routeParam) => {
  const decoded = decodeURIComponent(String(routeParam || ''));
  const separatorIndex = decoded.lastIndexOf(UNIQUE_SEPARATOR);
  return separatorIndex >= 0
    ? decoded.slice(separatorIndex + UNIQUE_SEPARATOR.length)
    : decoded;
};

export const productRoute = (product) => {
  const name = product?.product_brand || product?.name || product?.brand || product || 'product';
  return namedRoutePath('/products', name, product?.route_slug);
};

export const editProductRoute = (product) => {
  const name = product?.product_brand || product?.name || product?.brand || product || 'product';
  return namedRoutePath('/sell/product/edit', name, product?.route_slug);
};

export const sellerRoute = (seller) => {
  const name = seller?.company_name || seller?.companyName || seller?.full_name
    || seller?.seller_name || seller?.name || seller || 'seller';
  return namedRoutePath('/sellers', name, seller?.route_slug);
};

export const sellerReviewsRoute = (seller) => `${sellerRoute(seller)}/reviews`;

export const orderRoute = (order, basePath = '/orders', identifier) => {
  const base = String(basePath || '/orders').replace(/\/$/, '');
  const reference = identifier
    ?? order?.order_code
    ?? order?.id_order
    ?? (typeof order === 'string' || typeof order === 'number' ? order : '');
  return `${base}/${encodeURIComponent(String(reference))}`;
};
